import {Button} from '@material-ui/core'
import {RouteComponentProps} from '@reach/router'
import {MdAssignmentTurnedIn, MdBook, MdDescription} from 'react-icons/md'
import {toast} from 'react-toastify'
import {Avatar, Box} from 'reoil'
import BtnBottom from '../components/BtnBottom'
import Cell from '../components/Cell'
import Navigation from '../components/Navigation'
import useFetchResume from '../hooks/api/useFechResume'
import {useSetLoginState} from '../store/loginState'
import {palette} from '../theme'
import goto from '../utils/goto'
import localSave from '../utils/localSave'
import {responseBoxProp} from '../utils/propsHelpers'

const UserPage: React.FC<RouteComponentProps> = () => {
  const setLoginState = useSetLoginState()

  const {data} = useFetchResume()
  const hasResume = !!data?.data.userName

  // 数据
  const info = data?.data

  const isDeliverd = info?.deliveredJobs && info.deliveredJobs.length !== 0

  const isFinishedSurvey = data?.data.finishedSurvey as boolean

  // 点击退出登录
  const handleClickLogout = () => {
    localSave.set('token', '')
    setLoginState({isLogin: false, avatar: ''})
    goto('/', {replace: true})
    toast('已退出登录', {type: 'default'})
  }

  // 点击我的调研
  const handleClickDiaoyan = () => {
    goto('/user/survey')
  }

  // 点击我的简历
  const handleClickResume = () => {
    if (hasResume) {
      goto('/user/resume')
    } else {
      goto('/user/resume/create')
    }
  }

  // 点击我的投递
  const handleClickMyDelivered = () => {
    if (!isDeliverd) {
      goto('/jobs')
      toast('您还没有投递，请先投递岗位', {type: 'default'})
      return
    }
    goto('/user/delivered')
  }

  return (
    <Box className='UserPage' stretch>
      <Navigation title='个人中心' hideAvatar height={59} />

      <Box className='avatar' bg='white' center height={140}>
        <Avatar
          border='divider'
          boxShadow='card'
          size={50}
          mb={8}
          src={info?.headImg as string}
        />
        <Box fontSize={2} fontWeight='bold'>
          <p style={{margin: 0}}>{info?.userName}</p>
        </Box>
      </Box>
      <Box p={3} stretch bg='white'>
        <Cell
          {...responseBoxProp}
          icon={<MdAssignmentTurnedIn size={20} />}
          title='我的投递'
          desc={isDeliverd ? '' : '未投递'}
          onClick={handleClickMyDelivered}
        />
        <Cell
          {...responseBoxProp}
          icon={<MdDescription size={20} />}
          title={hasResume ? '我的简历' : '创建简历'}
          iconColor='secondary'
          onClick={handleClickResume}
        />
        <Cell
          {...responseBoxProp}
          icon={<MdBook size={20} />}
          title='心理测试'
          iconColor='mediumslateblue'
          onClick={handleClickDiaoyan}
          disabled={isFinishedSurvey}
          desc={isFinishedSurvey ? '已完成' : ''}
        />
      </Box>
      <Box mt={2} stretch center color={palette.red} bg='white' py={2}>
        <Button
          color='inherit'
          size='small'
          variant='text'
          onClick={handleClickLogout}>
          退出登录
        </Button>
      </Box>

      <BtnBottom center fontSize={1} lineHeight={1.3}>
        <Box>关注微信公众号“南方财经校园招聘”</Box>
        <Box>随时关注最新招聘情况</Box>
      </BtnBottom>
    </Box>
  )
}

export default UserPage
